var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.homeSettingInfo.is_footer && _vm.homeSettingInfo.is_footer == 1)?_c('div',[_c('div',{staticClass:"footerBg",class:{ footerBgM: _vm.mFlage },style:({
      background: _vm.homeSettingInfo.footer_background_color,
      textAlign:
        _vm.homeSettingInfo.aligning_type == 1
          ? 'left'
          : _vm.homeSettingInfo.aligning_type == 2
          ? 'center'
          : 'right',
      color: _vm.homeSettingInfo.footer_text_color,
    })},[_c('p',[_vm._v(_vm._s(_vm.homeSettingInfo.copyright))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.homeSettingInfo.archival_info))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }